// Generated by purs version 0.15.15
var callCC = function (dict) {
    return dict.callCC;
};
export {
    callCC
};
//# sourceMappingURL=index.js.map
